import { render, staticRenderFns } from "./DueDateOffsetField.vue?vue&type=template&id=0a2c7588&scoped=true"
import script from "./DueDateOffsetField.vue?vue&type=script&lang=js"
export * from "./DueDateOffsetField.vue?vue&type=script&lang=js"
import style0 from "./DueDateOffsetField.vue?vue&type=style&index=0&id=0a2c7588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2c7588",
  null
  
)

export default component.exports